/**
 * Add callback for intercepted cart data.
 *
 * @since 1.0.0
 */

import { getCallbacks } from '../init-fetch-interceptor';
import type { InterceptedData, InterceptorCallback } from '../types';
import type { SubscriptionOptions } from './types';

/**
 * Add callback for intercepted cart data.
 *
 * @since 1.0.0
 *
 * @param callback - Function to call when cart data is intercepted.
 * @param options - Optional subscription options.
 * @return Unsubscribe function.
 */
export const onCartAddItem = (
  callback: InterceptorCallback,
  options: SubscriptionOptions = {}
): (() => void) => {
  const { once = false, includeErrors = true } = options;
  const callbacks = getCallbacks();

  // Create wrapper callback to handle options
  const wrappedCallback: InterceptorCallback = (data: InterceptedData) => {
    // Filter out error responses if includeErrors is false
    if (!includeErrors && !data.response) {
      return;
    }

    callback(data);

    // Remove callback if it should only run once
    if (once) {
      callbacks.delete(wrappedCallback);
    }
  };

  callbacks.add(wrappedCallback);

  // Return unsubscribe function
  return () => {
    callbacks.delete(wrappedCallback);
  };
};
